import {Action} from '@ngrx/store';

export const PAGE_STATE_RESET = '[DienstplanPage] Page State reset';
export const BENUTZER_SUCHEN = '[DienstplanPage] Benutzer suchen';
export const IGNORE_WS_ACTION = '[DienstplanPage] WS Action ignoriert';
export const PAGE_DATEN_LADEN = '[DienstplanPage] Page Daten Laden';

export const SETZE_BENUTZER_ANZEIGEN = '[DienstplanPage] Setze Benutzer anzeigen';
export const SETZE_KONTAKTE_ANZEIGEN = '[DienstplanPage] Setze Kontakte anzeigen';

export const TOGGLE_FUNKTIONSBEREICHE_ACTION = '[DienstplanPage] Toggle Funktionsbereiche';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

export class PageLoadDataAction implements Action {
    readonly type = PAGE_DATEN_LADEN;

    constructor() {
    }
}


// BENUTZER
export class BenutzerSuchenAction implements Action {
    readonly type = BENUTZER_SUCHEN;

    constructor(public filterString: string) {
    }
}

export class SetzeBenutzerAnzeigenAction implements Action {
    readonly type = SETZE_BENUTZER_ANZEIGEN;

    constructor() {}
}

export class SetzeKontakteAnzeigenAction implements Action {
    readonly type = SETZE_KONTAKTE_ANZEIGEN;

    constructor() {}
}

export class ToggleFunktionsbereicheAction implements Action {
    readonly type = TOGGLE_FUNKTIONSBEREICHE_ACTION;

    constructor(public fbId: string) {
    }
}

export type Actions =
    BenutzerSuchenAction
    | PageStateResetAction
    | IgnoreWSAction
    | PageLoadDataAction
    | SetzeBenutzerAnzeigenAction
    | SetzeKontakteAnzeigenAction
    | ToggleFunktionsbereicheAction
    ;
